import { Component } from '@angular/core';

@Component({
    selector: 'app-shell-pages',
    templateUrl: './shell-pages.component.html',
    styleUrls: ['./shell-pages.component.scss'],
    standalone: false
})
export class ShellPagesComponent {
}
